import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./ScorllToTop";
import { checkAppVersion } from "./utils/versionCheck";
import HomePage from "./Pages/Website/HomePage";
import Register from "./Pages/Auth/Rejster";
import Login from "./Pages/Auth/Login";
import ResetPassword from "./Pages/Auth/ResetPassword";
import ForgetPassword from "./Pages/Auth/ForgetPassword";
import Courses from "./Pages/Website/Courses";
import CoursesList from "./Pages/Website/CoursesList";
import GradeCourses from "./Pages/Website/GradeCourses";
import Learn from "./Pages/Website/Learn";
import Lesson from "./Pages/Website/Lesson";
import Exam from "./Pages/Website/Exam";
import ResaltExam from "./Pages/Website/RsaltExam";
import Aboutus from "./Pages/Website/Aboutus";
import Profile from "./Pages/Website/Profile";
import TeacherProfile from "./Pages/Website/TeacherProfile";
import DashboardLayout from "./Components/Dashboard/DashboardLayout";
import DashboardHome from "./Components/Dashboard/Page/DashboardHome";
import Content from "./Components/Dashboard/Page/Content";
import Messages from "./Components/Dashboard/Page/Messages";
import Users from "./Components/Dashboard/Page/Users";
import Ads from "./Components/Dashboard/Page/Ads";
import Setting from "./Components/Dashboard/Page/Setting";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentRequest from "./Pages/Website/PaymentRequest";
import Invoice from "./Pages/Website/Invoice";
import StudeyLevel from "./Components/Dashboard/Page/StudyLevels";
import StudyMonths from "./Components/Dashboard/Page/StudyMonths";
import LessonsDashbord from "./Components/Dashboard/Page/LessonsDashbord";
import Add from "./Components/Dashboard/Page/Add";
import Update from "./Components/Dashboard/Page/Update";
import AddMonth from "./Components/Dashboard/Page/AddMonth";
import UpdateMonth from "./Components/Dashboard/Page/UpdateMonth";
import Addlesson from "./Components/Dashboard/Page/AddLesson";
import UpdateLesson from "./Components/Dashboard/Page/UpdateLesson";
import StudentQuery from "./Components/Dashboard/Page/StudentQuery";
import ContactMessage from "./Components/Dashboard/Page/ContactMessage";
import Money from "./Components/Dashboard/Page/Money";
import Teachers from "./Components/Dashboard/Page/Teachers";
import AddTeacher from "./Components/Dashboard/Page/AddTeacher";
import CreateTest from "./Components/Dashboard/Page/CreateTest";
import CreateQuesan from "./Components/Dashboard/Page/CreateQuesan";
import AddTest from "./Components/Dashboard/Page/AddTest";
import UpdateTest from "./Components/Dashboard/Page/UpdateTest";
import AddQuesthion from "./Components/Dashboard/Page/AddQuesthan";
import UpdateQuestion from "./Components/Dashboard/Page/UpdateQuestion";
import CreateFullExam from "./Components/Dashboard/Page/CreateFullExam";
import AddAds from "./Components/Dashboard/Page/AddAds";
import UpdateAds from "./Components/Dashboard/Page/UpdateAds";
import TaskDashbord from "./Components/Dashboard/Page/TaskDashbord";
import AddTask from "./Components/Dashboard/Page/AddTask";
import UpdateTask from "./Components/Dashboard/Page/UpdateTask";
import AssignmentsDashboard from "./Components/Dashboard/Page/AssignmentsDashboard";
import CourseDiscounts from "./Components/Dashboard/Page/CourseDiscounts";
import ProtectedRoute from "./Components/common/ProtectedRoute";
import ProtectedUserRoute from "./Components/common/ProtectedUserRoute";
import { DataRefreshProvider } from "./Pages/context/DataRefreshContext";
import CombosDashboard from "./Components/Dashboard/Page/CombosDashboard";
import AddCombo from "./Components/Dashboard/Page/AddCombo";
import UpdateCombo from "./Components/Dashboard/Page/UpdateCombo";
import ComboDetail from "./Pages/Website/ComboDetail";
import ComboInvoice from "./Pages/Website/ComboInvoice";
import CoursePackagesDashboard from "./Components/Dashboard/Page/CoursePackagesDashboard";
import AddCoursePackage from "./Components/Dashboard/Page/AddCoursePackage";
import UpdateCoursePackage from "./Components/Dashboard/Page/UpdateCoursePackage";
import CoursePackageDetail from "./Pages/Website/CoursePackageDetail";
import CoursePackageInvoice from "./Pages/Website/CoursePackageInvoice";
import MonthlySummary from "./Components/Dashboard/Page/MonthlySummary";
import LandingCardsDashboard from "./Components/Dashboard/Page/LandingCardsDashboard";

function DashboardHomeSelector() {
  return <DashboardHome />;
}

export default function App() {
  useEffect(() => {
    checkAppVersion();
  }, []);

  return (
    <DataRefreshProvider>
      <div className="App">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ScrollToTop />
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/payment" element={<PaymentRequest />} />
        <Route path="/invoice/:courseId" element={<ProtectedUserRoute><Invoice /></ProtectedUserRoute>} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/courses" element={<Courses />}>
          <Route path="general" element={<CoursesList type="general" />} />
          <Route path="azhar" element={<CoursesList type="azhar" />} />
        </Route>
        <Route path="/courses/grade/:gradeId" element={<GradeCourses />} />
        <Route path="/learn/:id" element={<ProtectedUserRoute><Learn /></ProtectedUserRoute>} />
        <Route path="/profile" element={<ProtectedUserRoute><Profile /></ProtectedUserRoute>} />
        <Route path="/lesson/:id" element={<ProtectedUserRoute><Lesson /></ProtectedUserRoute>} />
        <Route path="/exam/:id" element={<ProtectedUserRoute><Exam /></ProtectedUserRoute>} />
        <Route path="/resalt-exam/:id" element={<ProtectedUserRoute><ResaltExam /></ProtectedUserRoute>} />
        <Route path="/teacher/:teacherId" element={<TeacherProfile />} />
        <Route path="/combos/:comboId" element={<ComboDetail />} />
        <Route path="/invoice/combo/:comboId" element={<ProtectedUserRoute><ComboInvoice /></ProtectedUserRoute>} />
        <Route path="/packages/:packageId" element={<CoursePackageDetail />} />
        <Route path="/invoice/package/:packageId" element={<ProtectedUserRoute><CoursePackageInvoice /></ProtectedUserRoute>} />

        {/* Dashbord */}
        <Route
          path="/DashboardLayout"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="content" element={<Content />} />
          <Route path="content/add" element={<Add />} />
          <Route path="content/update" element={<Update />} />
          <Route path="content/addmonth" element={<AddMonth />} />
          <Route path="content/updatemonth" element={<UpdateMonth />} />
          <Route path="content/addlesson" element={<Addlesson />} />
          <Route path="content/updatelesson" element={<UpdateLesson />} />
          <Route path="content/academic" element={<StudeyLevel />} />
          <Route path="content/months" element={<StudyMonths />} />
          <Route path="content/lessons" element={<LessonsDashbord />} />
          <Route path="content/assignments" element={<AssignmentsDashboard />} />
          <Route path="messages" element={<Messages />} />
          <Route path="messages/student-queries" element={<StudentQuery />} />
          <Route path="messages/contact" element={<ContactMessage />} />
          <Route path="tests/create-test" element={<CreateTest />} />
          <Route path="tests/create-full-exam" element={<CreateFullExam />} />
          <Route path="tests/addtest" element={<AddTest />} />
          <Route path="tests/updatetest" element={<UpdateTest />} />
          <Route path="tests/create-question" element={<CreateQuesan />} />
          <Route path="tests/addquestion" element={<AddQuesthion />} />
          <Route path="tests/updatequestion" element={<UpdateQuestion />} />
          <Route path="users" element={<Users />} />
          <Route path="teachers" element={<Teachers />} />
          <Route path="teachers/add" element={<AddTeacher />} />
          <Route path="money" element={<Money />} />
          <Route path="monthly-summary" element={<MonthlySummary />} />
          <Route path="discounts" element={<CourseDiscounts />} />
          <Route path="combos" element={<CombosDashboard />} />
          <Route path="combos/add" element={<AddCombo />} />
          <Route path="combos/update/:id" element={<UpdateCombo />} />
          <Route path="packages" element={<CoursePackagesDashboard />} />
          <Route path="packages/add" element={<AddCoursePackage />} />
          <Route path="packages/update/:id" element={<UpdateCoursePackage />} />
          <Route path="ads" element={<Ads />} />
          <Route path="addads" element={<AddAds />} />
          <Route path="updateads" element={<UpdateAds />} />
          <Route path="taskDashbord" element={<TaskDashbord />} />
          <Route path="addTask" element={<AddTask />} />
          <Route path="updateTask" element={<UpdateTask />} />
          <Route path="settings" element={<Setting />} />
          <Route path="landing-cards" element={<LandingCardsDashboard />} />
        </Route>

        <Route path="/AdminDashboard/*" element={<Navigate to="/DashboardLayout" replace />} />
      </Routes>
      </div>
    </DataRefreshProvider>
  );
}
